import React from 'react';
import { ProjectsContentPlayful } from './ProjectsContent';
import { ProjectsProvider } from '../provider';
import { BottomBarInfantil } from '@/components/custom/bottom-bar-infantil';
import { Dashboard } from '@/layouts/dashboard';
import { ProjectWorkspace } from '@/components/custom/project';

// Workspace do projeto no tema playful: troca o menu lateral corporativo
// (<Menu />) pela bottom bar lúdica, e não reserva a margem esquerda de
// 64px pensada para aquele menu fixo. A variante corporativa (admin ou
// aluno fora do tema playful) continua em ../Default/ProjectsView.jsx.
// A navegação entre versões (antes numa sidebar fixa própria, ProjectsListPlayful)
// foi consolidada dentro da aba "Versões" de ProjectsContentPlayful.
export default function ProjectsViewPlayful({ projectId }) {
  return (
    <Dashboard>
      <BottomBarInfantil />

      <ProjectWorkspace>
        <ProjectsProvider>
          <ProjectsContentPlayful projectId={projectId} />
        </ProjectsProvider>
      </ProjectWorkspace>
    </Dashboard>
  );
}
